import { useEffect, useMemo } from "react";
import { InputDecimal3 } from "src/framework/components/forms/inputs/InputDecimal3"
import { useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store";
import { FormProjetoOffGridType } from "../../../types";
import { InputPrefix } from "./InputPrefix";

interface AutonomiaBateriaInputProps {
  errorState: string[];
  onChangeError: (errorState: any) => void
  formState: FormProjetoOffGridType;
  onChangeValue: (formState: Partial<FormProjetoOffGridType>) => void;
}

const MIN_VALUE_CHUMBO = 24;
const MAX_VALUE_CHUMBO = 240

const MIN_VALUE_LITIO = 15
const MAX_VALUE_LITIO = 240

export const AutonomiaBateriaInput = ({ errorState, onChangeError, formState, onChangeValue }: AutonomiaBateriaInputProps) => {
  const projetosOffGridValidationsStoreState = useProjetosOffGridStore(store => store.state.validations)
  const projetosOffGridStoreActions = useProjetosOffGridStore(store => store.actions)

  const helperText = useMemo(()=>{
    if (!formState?.autonomia_banco_bateria) return ""
    if (!formState?.tipo_bateria) return ""
    
    const tipoBateria = formState?.tipo_bateria?.id || null;
    
    const minValue = tipoBateria === "litio" ? MIN_VALUE_LITIO : MIN_VALUE_CHUMBO;
    const maxValue = tipoBateria === "litio" ? MAX_VALUE_LITIO : MAX_VALUE_CHUMBO;
    
    if (!tipoBateria) return ""
    
    if (formState.autonomia_banco_bateria < minValue) return `Valor mínimo aceitável é de ${minValue} horas`
    if (formState.autonomia_banco_bateria > maxValue) return `Valor máximo aceitável é de ${maxValue} horas`
    
    return ""
  },[formState?.autonomia_banco_bateria, formState?.tipo_bateria])

  const disabled = useMemo(()=>{
    return !formState?.tipo_bateria || !projetosOffGridValidationsStoreState?.tipo_bateria.status
  },[formState?.tipo_bateria, projetosOffGridValidationsStoreState?.tipo_bateria.status])

  useEffect(()=>{
    projetosOffGridStoreActions.changeValidationsValue({ autonomia_bancos_bateria: { status: !helperText, helper: helperText } })
  },[helperText, projetosOffGridStoreActions])

  return (
    <InputDecimal3
      label={"* Autonomia do banco de baterias"}
      helperText={helperText}
      prefix={<InputPrefix styles={{ marginLeft: '-9px' }} />}
      disabled={disabled}
      margin="normal"
      sufix="horas"
      decimal={0}
      error={!!helperText || errorState.includes('autonomia_banco_baterias')}
      maxLength={3}
      allowNegative={false}
      value={formState?.autonomia_banco_bateria || ''}
      onChange={(event: any) => onChangeValue({ recalcular: true, autonomia_banco_bateria: event.target.value ? Number(event.target.value) : 0 })}
    />
  )
}